import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import tooltip from '@/mixins/components/tooltip';

export default Vue.component('edit-group-list', {
  template: require('./template.html'),
  name: 'edit-group-list',
  props: ['droplet', 'show-edit-bubble'],
  components: {
    tooltip,
  },
  computed: {
    ...mapGetters(['currentSite']),
    enabledTypes() {
      const { type, addedTypes = [] } = this.currentSite;
      const allTypes = ['Choose...', type].concat(addedTypes);
      return _.uniq(allTypes).filter(type => type !== 'general');
    },
  },
  data() {
    return {
      display: {
        visible: 0,
        loadMoreText: '',
        siteType: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.display.visible = this.droplet.visible;
      this.display.loadMoreText = this.droplet.loadMoreText;
      this.display.siteType = this.droplet.siteType || this.enabledTypes[0];
    },
    setDynamicType() {
      this._debounce(() => {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          val: this.display.siteType || null,
          key: 'siteType',
        });
        this.bouncePlugin();
      }, 250);
    },
    debounceSet(params) {
      this._debounce(() => {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: params.key,
          val: this.display[params.key],
        });
        this.bouncePlugin();
      }, 300);
    },
    async bouncePlugin() {
      await this.$vnode.context.destroyPlugin();
      this.$vnode.context.initPlugin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/group-list/components/_edit-options/index.js